import { registerLessonRefreshBlocker } from "@/lib/lesson-refresh-guard";
import { useEffect } from "react";

const BUSY_STATES = new Set(["connecting", "connected", "reconnecting", "disconnecting"]);

export function useLessonRefreshProtection({
  connectionState,
  isConnected,
  isRecording,
  isTransportActive,
}: {
  connectionState: string;
  isConnected: boolean;
  isRecording: boolean;
  isTransportActive: () => boolean;
}) {
  useEffect(
    () =>
      registerLessonRefreshBlocker(
        () => isConnected || isRecording || BUSY_STATES.has(connectionState) || isTransportActive()
      ),
    [connectionState, isConnected, isRecording, isTransportActive]
  );
}
